import type { Appointment } from "@myapp/contract";

export const getAppointmentAttachmentTotal = (a: Appointment): number =>
  (a.attachments?.length ?? 0) + (a.workOrder?.external?.immotionAttachmentsCount ?? 0);
